import { render, staticRenderFns } from "./LabelGenerator.vue?vue&type=template&id=5e236282"
import script from "./LabelGenerator.vue?vue&type=script&lang=js"
export * from "./LabelGenerator.vue?vue&type=script&lang=js"
import style0 from "./LabelGenerator.vue?vue&type=style&index=0&id=5e236282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports